import FriendsGroup from './FriendsGroup';
import './friend.css';

const Friend = ({friends, isFriend, isSetFriend}) => {

      const closeFriend = () => {
            isSetFriend(false);
      }
      
      return (
            <div className={(isFriend) ? "friend show" : "friend"}>
                  <div className="friend_content">
                        <div className="friend_group">
                              <FriendsGroup friends={friends} />
                        </div>
                        <button className="close_friend" onClick={() => closeFriend()}>Close</button>
                  </div>
            </div>
      )
}

export default Friend;